import React, { ReactElement } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import { IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function AboutButton(): ReactElement {
  const navigate = useNavigate();
  return (
    <Tooltip title="Information about StoryPoint.Poker" aria-label="About">
      <IconButton
        onClick={() => navigate('/about')}
        color="inherit"
      >
        <InfoIcon />
      </IconButton>
    </Tooltip>
  );
}